import React from 'react';
import { useTranslation } from 'react-i18next';
import 'assets/css/maintenance.scss';

const Maintenance = () => {
  const { t } = useTranslation(['maintenance']);
  
  return (
    <div className="maintenance-container">
      <div className="container w-100">
        <h1 className="title text-center">
          {t('inmaintenance')}
        </h1>
        <p>{t('inconvenience')}</p>
        <div className="spinner"></div>
      </div>
    </div>
  );
};

export default Maintenance;
